<template>
  <div>
    <div class="flex rightTop">
      <div class="flex-sub" @click="tapTc">
        <div class="top1"> <img src="../assets/img2.png" alt="">销售数据</div>
        <div class="top3">6843320<span>元</span></div>
        <!-- <div class="top3">{{ toFixed(dataVal.销售数据/100) }} <span>元</span></div> -->
      </div>
      <div class="flex-sub" @click="tapTc">
        <div class="top1"><img src="../assets/img3.png" alt="">订单量</div>
        <div class="top3">42944 <span>单</span></div>
        <!-- <div class="top3">{{ toFixed(dataVal.订单量) }} <span>单</span></div> -->
      </div>
      <div class="flex-sub" @click="tapTc">
        <div class="top1"><img src="../assets/img4.png" alt="">注册量</div>
        <div class="top3"> 124869 <span>人</span></div>
        <!-- <div class="top3">{{ toFixed(dataVal.注册量) }} <span>人</span></div> -->
      </div>
      <div class="flex-sub" @click="tapTc">
        <div class="top1"><img src="../assets/img5.png" alt="">人均消费</div>
        <div class="top3"> 54 <span>元</span></div>
        <!-- <div class="top3">{{ toFixed(dataVal.人均消费/100) }} <span>元</span></div> -->
      </div>
    </div>
    <Echart id="rightTop" :options="options" height="175px" v-if="pageflag" ref="rightTop" />
   
  </div>
</template>

<script>
export default {
 
  data() {
    return {
      pageflag: true,
      options: {},
      timer: null
    }
  },
  props: {
  	  dataVal: {
  	        type: Object,
  	        default: () => ({})
  	      }
  },
  watch: {
  	  dataVal: {
  		  handler(newData) {
  			  this.$nextTick(() => {
  				  this.getData()
  			  })
  		  },
  		  immediate: true,
  		  deep: true
  	  }
  },
  mounted() {
    this.getData()
  },
  beforeDestroy() {
    this.clearData()
  },
  methods: {
    mapclick() {
      // if (this.echartBindClick) return;
      // this.$refs.rightTop.chart.on("click", (params) => {
      //   this.$emit("openShow","righttop")
      //   console.log('righttop')
      // });
      // this.echartBindClick = true;
    },
    tapTc() {
      this.$emit("openShow",{name:"RightTop"})
    },
    toFixed(val) {
      let num = parseFloat(val).toLocaleString("en", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      let actualNum = num.split(".");
      if (actualNum[1] > 0) {
        return num;
      } else {
        return actualNum[0];
      }
    },
    getData() {
      console.log(this.dataVal,"测试lefttop数据")
      this.pageflag = true
      setTimeout(() => {
        ////////////////////////////
      
let total = 66
let data1 = this.dataVal.typedata
this.options = {
    tooltip: {
        trigger: 'item',
    },
    title: [{
        zlevel: 0,
        text: '商户类型',
        top: '47.6%',
        left: '39%',
        textAlign: 'center',
        textStyle: {
            color: '#fff',
            fontSize: 14,
        },
        subtextStyle: {
            fontSize: 12,
            color: '#fff',
        },
    }],
    legend: {
        orient: 'vertical',
        right: 10,
        top: 40,
        bottom: 5,
        itemWidth: 15, // 图例图形的宽度
        itemHeight: 10, // 图例图形的高度
        itemGap: 10,
        textStyle: {
            color: '#fff',
            fontSize: 14,
            marginTop: 60,
        },
    },
    series: [
        {
            color: ['#163d59'],
            type: 'gauge',
            center: ['40%', '55%'],
            startAngle: 150,
            endAngle: -209.999,
            splitNumber: 12,
            radius: '60%',
            pointer: {
                show: false,
            },
            progress: {
                show: false,
                roundCap: true,
                width: 1,
            },
            axisLine: {
                show: false,
                lineStyle: {
                    width: 10,
                    color: [
                        [0, '#163d59'],
                        [0.5, '#163d59'],
                        [1, '#163d59'],
                    ],
                },
            },
            axisTick: {
                distance: -20,
                length: 5,
                splitNumber: 10,
                lineStyle: {
                    width: 1,
                    color: '#099fe4',
                },
            },
            splitLine: {
                distance: -25,
                length: 10,
                lineStyle: {
                    width: 2,
                    color: '#099fe4',
                },
            },
            axisLabel: {
                show: false,
            },
            anchor: {
                show: false,
            },
            title: {
                show: false,
            },
            detail: {
                show: false,
            },
            data: [],
        },
        {
            color: ['#15e1fc', '#12b795', '#1d8ac4', '#1cadfe'],
            name: '',
            type: 'pie',
            radius: ['40%', '55%'],
            center: ['40%', '55%'],
            startAngle: 150,
            avoidLabelOverlap: false,
            itemStyle: {
                // borderColor: '#122227',
                borderColor: 'transparent',
                borderWidth: 3,
            },
            labelLine: {
                length: 30,
            },
            label: {
                bleedMargin: 5,
                alignTo: 'labelLine',
                position: 'outer',
                formatter: '{a|{c}({d}%)}\n {per|{b}} ',
                backgroundColor: 'rgba(0, 0, 0, 0)',
                borderColor: 'rgba(0, 0, 0, 0)',
                borderWidth: 1,
                borderRadius: 4,

                rich: {
                    a: {
                        color: '#fff',
                        lineHeight: 14,
                        align: 'center',
                        fontSize: 12,
                    },
                    hr: {
                        borderColor: 'auto',
                        width: '100%',
                        borderWidth: 1,
                        height: 0,
                    },
                    per: {
                        color: '#1ef0ed',
                        backgroundColor: 'rgba(0, 0, 0, 0)',
                        padding: [2, 5],
                        borderRadius: 4,
                        fontSize: 12,
                    },
                },
            },
            data: [],
        },
    ],
};

this.options.series[1].data = data1

        ///////////////////////////
        this.mapclick()
      }, 2000);
    },
    clearData() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
  }
}
</script>

<style scoped lang="scss">
.flex {
  display: flex;
  .flex-sub {
    flex: 1;
  }
}
.rightTop {
  padding: 0 10px 10px;
  .top1 {
    height: 40px;
    line-height: 40px;
    background-repeat: no-repeat;
    color: #c3ced4;
    font-weight: 700;
    font-size: 16px;
    display:flex;
    align-items: center;
    padding-left: 5px;
    img {
      padding-right: 5px;
    }
  }
  .top3 {
    color: #22dafe;
    font-size: 20px;
    padding-left: 5px;
    span {
      font-size:14px;
      color:#fff;
    }
  }

}
</style>